// extracted by mini-css-extract-plugin
export default {"gallery":"sparkle_gallery__Yd5Jf","col":"sparkle_col__vvfma","imagetitle":"sparkle_imagetitle__4mFyn","btn1":"sparkle_btn1__au8v8"};